import { render, staticRenderFns } from "./ShortLinkView.vue?vue&type=template&id=24b08472&scoped=true"
import script from "./ShortLinkView.vue?vue&type=script&lang=js"
export * from "./ShortLinkView.vue?vue&type=script&lang=js"
import style0 from "./ShortLinkView.vue?vue&type=style&index=0&id=24b08472&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "24b08472",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/opt/buildhome/repo/admin-ui/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('24b08472')) {
      api.createRecord('24b08472', component.options)
    } else {
      api.reload('24b08472', component.options)
    }
    module.hot.accept("./ShortLinkView.vue?vue&type=template&id=24b08472&scoped=true", function () {
      api.rerender('24b08472', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/Common/ShortLinkView.vue"
export default component.exports